import { render, staticRenderFns } from "./file-uploader.vue?vue&type=template&id=e54c2a16&scoped=true&lang=html&"
import script from "./file-uploader.vue?vue&type=script&lang=js&"
export * from "./file-uploader.vue?vue&type=script&lang=js&"
import style0 from "./file-uploader.vue?vue&type=style&index=0&id=e54c2a16&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54c2a16",
  null
  
)

export default component.exports